import './desensitize';
import $ from 'jquery';
import './login.less';

// TODO: 和ui-common里的appurl合并
function appurl(url) {
  return (window.appUrlPrefix || '') + url;
}

function getText(key, ...args) {
  // Use a regular expression to find placeholders in the string
  const placeholderRegex = /\$(\d+)/g;

  // Replace each placeholder with the corresponding argument value
  const replacedString = TEXTS[localStorage.locale][key].replace(
    placeholderRegex,
    (match, index) => {
      const argIndex = parseInt(index, 10);
      return args.length > argIndex ? args[argIndex] : match;
    }
  );

  return replacedString;
}

const TEXTS = {
  'zh-CN': {
    usernamePasswordErrorMessage: '用户名/密码错误',
    accountLockedMessage:
      '账号被锁定，请联系租户管理员在用户管理中进行解锁和重置密码，点击<a href="https://mp.weixin.qq.com/s/gKJ4cLgsHDLgRVzoe-Pzig" target="_blank">了解详细操作步骤</a>，如有疑问可拨打400-850-9918咨询',
    accountFrozenMessage: '账号被冻结，如有疑问可拨打400-850-9918咨询',
    temporaryLockMessage: '账号被临时锁定30分钟，请30分钟后再试。如有疑问可拨打400-850-9918咨询。',
    baseMessageError: '抱歉，不存在该邮箱，请核实后重新登录！',
    enterMobileOrEmail: '请输入手机号或者邮箱',
    enterCorrectFormat: '请输入正确格式的手机号或者邮箱',
    enterVerificationCode: '请输入您收到的验证码',
    captchaErrorMessage: '请输入正确的验证码',
    enterNewPassword: '请输入您的新密码',
    newPasswordRequirements: '新密码长度10-20位，必须包含大小写字母和数字和特殊字符(#?!@$%^&*-)',
    enterPasswordAgain: '请输入再输一遍您的新密码',
    passwordsNotMatch: '两次密码不一致',
    passwordChangeFailed: '密码修改失败, 请刷新后重试',
    loginException: '登录异常，请重试',
    activationRequired: '当前服务账号没有激活',
    incorrectVerificationCode: '验证码不正确,请稍后再试',
    verificationCodeLocked: `验证失败超过五次,此帐号将被锁定$0，请稍后再试`,
    userDisabled: '抱歉，不能登录！',
    captchaShowError: '验证太频繁，请稍后再试。',
    captchaValidationError: '验证失败',
    ssoUserNotSupported: '该用户是单点登录用户，请在对应第三方平台找回密码',
    sendVerificationCodeFailed: '发送验证码失败,请稍后再试',
    resendVerificationCode: '重发验证码',
    verificationCodeShouldWait: '发送验证码太频繁,请稍后再试',
    emailNotFoundUser: `没有找到该用户的邮箱`,
    phoneNotFoundUser: `没有找到该用户的手机号`,
    emailVerificationCodeSent: `验证码已发送至您的邮箱$0`,
    phoneVerificationCodeSent: `验证码已发送至您的手机号$0`,
  },
  'en-US': {
    usernamePasswordErrorMessage: 'Username/password incorrect',
    accountLockedMessage:
      'Account locked. Please contact the tenant administrator to unlock and reset the password. Click <a href="https://mp.weixin.qq.com/s/gKJ4cLgsHDLgRVzoe-Pzig" target="_blank">here</a> for detailed steps. If you have any questions, call 400-850-9918 for assistance.',
    accountFrozenMessage:
      'Account frozen. If you have any questions, call 400-850-9918 for assistance.',
    temporaryLockMessage:
      'Account temporarily locked for 30 minutes. Please try again after 30 minutes. If you have any questions, call 400-850-9918 for assistance.',
    baseMessageError: 'Sorry, the email does not exist. Please verify and log in again!',
    enterMobileOrEmail: 'Please enter your mobile number or email address',
    enterCorrectFormat: 'Please enter the correct mobile number or email address',
    enterVerificationCode: 'Please enter the verification code you received',
    captchaErrorMessage: 'Please enter the correct captcha',
    enterNewPassword: 'Please enter your new password',
    newPasswordRequirements:
      'New password must be 10-20 characters and include uppercase and lowercase letters, numbers, and special characters (#?!@$%^&*-)',
    enterPasswordAgain: 'Please enter your new password again',
    passwordsNotMatch: 'Passwords do not match',
    passwordChangeFailed: 'Password change failed. Please refresh and try again',
    loginException: 'Login exception. Please retry',
    activationRequired: 'Current service account is not activated',
    incorrectVerificationCode: 'Incorrect verification code. Please try again later',
    verificationCodeLocked: `Verification failed more than five times. This account will be locked for $0. Please try again later`,
    userDisabled: 'Sorry, unable to log in!',
    captchaShowError: 'Captcha verification is too frequent. Please try again later.',
    captchaValidationError: 'Captcha verification failed',
    ssoUserNotSupported:
      'This user is a Single Sign-On user. Please recover the password on the corresponding third-party platform',
    sendVerificationCodeFailed: 'Failed to send verification code. Please try again later',
    resendVerificationCode: 'Resend Verification Code',
    verificationCodeShouldWait:
      'Verification code is sent too frequently. Please wait and try again later',
    emailNotFoundUser: `User with email not found`,
    phoneNotFoundUser: `User with mobile number not found`,
    emailVerificationCodeSent: `Verification code has been sent to your email: $0`,
    phoneVerificationCodeSent: `Verification code has been sent to your mobile number: $0`,
  },
  'zh-TW': {
    usernamePasswordErrorMessage: '用戶名/密碼錯誤',
    accountLockedMessage:
      '帳號被鎖定，請聯繫租戶管理員進行解鎖和重置密碼。點擊<a href="https://mp.weixin.qq.com/s/gKJ4cLgsHDLgRVzoe-Pzig" target="_blank">這裡</a>查看詳細操作步驟。如有疑問可撥打400-850-9918咨詢。',
    accountFrozenMessage: '帳號被凍結，如有疑問可撥打400-850-9918咨詢。',
    temporaryLockMessage: '帳號暫時鎖定30分鐘，請30分鐘後再試。如有疑問可撥打400-850-9918咨詢。',
    baseMessageError: '抱歉，該郵箱不存在，請核實後重新登錄！',
    enterMobileOrEmail: '請輸入手機號碼或郵箱',
    enterCorrectFormat: '請輸入正確格式的手機號碼或郵箱',
    enterVerificationCode: '請輸入您收到的驗證碼',
    captchaErrorMessage: '請輸入正確的驗證碼',
    enterNewPassword: '請輸入您的新密碼',
    newPasswordRequirements:
      '新密碼長度必須為10-20位，必須包含大寫字母、小寫字母、數字和特殊字符(#?!@$%^&*-)',
    enterPasswordAgain: '請再次輸入新密碼',
    passwordsNotMatch: '兩次密碼不一致',
    passwordChangeFailed: '密碼修改失敗，請刷新後重試',
    loginException: '登錄異常，請重試',
    activationRequired: '當前服務帳號尚未激活',
    incorrectVerificationCode: '驗證碼不正確，請稍後再試',
    verificationCodeLocked: `驗證失敗超過五次，該帳號將被鎖定$0，請稍後再試`,
    userDisabled: '抱歉，無法登錄！',
    captchaShowError: '驗證太頻繁，請稍後再試。',
    captchaValidationError: '驗證失敗',
    ssoUserNotSupported: '該用戶是單點登錄用戶，請在相應第三方平台找回密碼',
    sendVerificationCodeFailed: '發送驗證碼失敗，請稍後再試',
    resendVerificationCode: '重新發送驗證碼',
    verificationCodeShouldWait: '發送驗證碼過於頻繁，請稍後再試',
    emailNotFoundUser: `未找到該用戶的郵箱`,
    phoneNotFoundUser: `未找到該用戶的手機號碼`,
    emailVerificationCodeSent: `驗證碼已發送至您的郵箱: $0`,
    phoneVerificationCodeSent: `驗證碼已發送至您的手機號碼: $0`,
  },
};

const JSEncrypt = require('jsencrypt').default;
var encrypt = new JSEncrypt();

const captcha = {
  forceShow: username =>
    $.ajax({
      url: '/captcha/show?username=' + username,
      type: 'get',
      dataType: 'json',
    }),
  init: () =>
    $.ajax({
      url: '/captcha/init',
      type: 'get',
      dataType: 'json',
    }),
  validate: (ticket, rands, data) =>
    $.ajax({
      url: `/account/validate?ticket=${ticket}&rands=${rands}`,
      type: 'POST',
      contentType: 'application/json;charset=UTF-8',
      data: JSON.stringify(data),
    }),
};

let needCaptcha;

const messageDom = message =>
  `
    <span>
        <div class="base-message-notice">
            <div class="base-message-notice-content">
                <div class="base-message-custom-content base-message-error">
                    <i aria-label="icon: close-circle" class="anticon anticon-close-circle"><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="close-circle" width="1em" height="1em" fill="#e34d59" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 0 1-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path></svg></i>
                    <span>${message}</span>
                </div>
            </div>
        </div>
    </span>
`;

const showMessage = (message, stayTime = 4) => {
  if ($('.base-message').length == 0) {
    const div = document.createElement('div');
    document.body.after(div);
    $(div).html('<div class="base-message"></div>');
  }

  $('.base-message').html(messageDom(message));
  setTimeout(() => $('.base-message').empty(), stayTime * 1000);
};

const getQueryString = () => {
  const search = window.location.search || '';
  const query = search.substr(1); // remove the '?' from the beginning
  const queryMap = {};
  query.split('&').map(str => {
    const [key, value] = str.split('=');
    queryMap[key] = value;
  });
  return queryMap;
};

const getTimeText = countDownNumber => {
  const minute = Math.floor(countDownNumber / 60);
  const seconds = countDownNumber % 60;

  let text = '';
  if (minute) {
    text += `${minute}分 `;
  }

  text += `${seconds}秒`;
  return text;
};

const getShowCaptcha = (needCaptcha, username) => {
  let promise;
  if (!needCaptcha && username) {
    promise = captcha
      .forceShow(username)
      .then(data => {
        if (data.showCaptcha) {
          return true;
        } else {
          return needCaptcha;
        }
      })
      .catch(() => false);
  } else {
    promise = $.ajax().then(() => needCaptcha);
  }
  return promise;
};

const showMessageAndCaptcha = async () => {
  //初始化验证码
  let appid;
  try {
    const initResult = await captcha.init();
    appid = initResult.appid;
  } catch (e) {
    // captcha init 失败（如缺少 tenant id）则不显示验证码
    return;
  }

  let captchaObj = {
    login: 'reject',
    forget: 'reject',
    verifyCode: 'reject',
    login2FA: 'reject',
  };

  let captchaEle = new CLCaptcha(
    appid,
    function (res) {
      // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"},（用户主动关闭验证码）= {ret: 2, ticket: null}
      if (res.ret === 0) {
        if (captchaObj.login === 'pending') {
          captchaObj.login = 'resolved';
          $('#dmhub_form').attr(
            'action',
            `/perform_login?ticket=${res.ticket}&rands=${res.randstr}`
          );
          document.getElementById('loginCaptchaBtn').click();
        } else if (captchaObj.forget === 'pending') {
          captchaObj.forget = 'reject';
          mobileOrMail = $('#mobileOrMail').val();
          getCode({
            ticket: res.ticket,
            randstr: res.randstr,
            mobileOrMail: $('#mobileOrMail').val(),
          });
        } else if (captchaObj.verifyCode === 'pending') {
          captchaObj.verifyCode = 'reject';
          mobileOrMail = $('#mobileOrMail').val();
          getCode({
            ticket: res.ticket,
            randstr: res.randstr,
            mobileOrMail: $('#mobileOrMail').val(),
          });
        } else if (captchaObj.login2FA === 'pending') {
          captchaObj.login2FA = 'reject';
          login2FA({
            ticket: res.ticket,
            randstr: res.randstr,
            loginName: $('#username').val(),
          });
        }
      } else {
        Object.keys(captchaObj).forEach(key => {
          captchaObj[key] = 'reject';
        });
      }
    },
    { showMessage: showMessage }
  );

  const queryMap = getQueryString();
  const username = queryMap.uname;
  needCaptcha = needCaptcha || queryMap.needCaptcha === 'true';
  if (username) {
    $('#username')[0].value = username;
  }

  $('#loginName').val(queryMap.username);

  needCaptcha = await getShowCaptcha(needCaptcha, username);

  //普通登录-获取验证码
  $('[data-type="login"] .verify-code').on('click', function (e) {
    if (captchaObj.login2FA === 'reject') {
      captchaObj.login2FA = 'pending';
      captchaEle.show();
      e.stopPropagation();
      e.preventDefault();
    }
  });

  //普通登录-登录
  document.getElementById('loginCaptchaBtn').addEventListener(
    'click',
    function (e) {
      if (captchaObj.login === 'reject' && needCaptcha) {
        captchaObj.login = 'pending';
        captchaEle.show();
        e.stopPropagation();
        e.preventDefault();
      }
    },
    true
  );

  //切换到【忘记密码】
  $('#forget-password').on('click', function () {
    $('[data-type="login"]').hide();
    $('[data-type="forget_step1"]').show();
    $('#mobileOrMail').val($('#username').val());
  });

  //忘记密码-下一步
  $('#nextStepBtn').on('click', function () {
    if (captchaObj.forget === 'reject') {
      mobileOrMail = $('#mobileOrMail').val();
      if (!mobileOrMail) {
        showMessage(getText('enterMobileOrEmail'));
        return;
      }
      if (
        !/^1\d{10}$/.test(mobileOrMail) &&
        !/^[\w-\.]+@[\w-]+(\.[a-z\d-]+)*(\.[a-z]{2,6})$/i.test(mobileOrMail)
      ) {
        showMessage(getText('enterCorrectFormat'));
        return;
      }
      captchaObj.forget = 'pending';
      captchaEle.show();
    }
  });

  //忘记密码-重发验证码
  $('[data-type="forget_step2"] .verify-code').on('click', function (e) {
    if (captchaObj.verifyCode === 'reject') {
      captchaObj.verifyCode = 'pending';
      captchaEle.show();
      e.stopPropagation();
      e.preventDefault();
    }
  });

  //忘记密码-提交
  $('[data-type="forget_step2"] .submit').on('click', function () {
    const code = $('#code').val();
    if (!code) {
      showMessage(getText('enterVerificationCode'));
      return;
    }

    const password1 = $('#password1').val();
    const password2 = $('#password2').val();

    if (!password1) {
      showMessage(getText('enterNewPassword'));
      return;
    }

    const reg = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*)(?=.*?[#?!@$%^&*-]).{10,20}$/;
    if (!reg.test(password1)) {
      showMessage(getText('newPasswordRequirements'));
      return;
    }

    if (!password1) {
      showMessage(getText('enterPasswordAgain'));
      return;
    }

    if (password1 !== password2) {
      showMessage(getText('passwordsNotMatch'));
      return;
    }

    $.ajax({
      url: '/loginSecurity/getEncryptLoginInfo',
      type: 'GET',
      contentType: 'application/json;charset=UTF-8',
    }).then(function (encryptInfo) {
      const data = {
        number: mobileOrMail,
        pwd: password1,
        token: code,
        type: type,
      };
      if (encryptInfo?.encryptLogin) {
        encrypt.setPublicKey(encryptInfo.pubKey);
        data.pwd = encrypt.encrypt(data.pwd);
        data.subKey = encryptInfo.subKey;
      }
      $.ajax({
        url: '/account/changePassword',
        type: 'POST',
        contentType: 'application/json;charset=UTF-8',
        data: JSON.stringify(data),
      }).then(function (result) {
        if (!result.error) {
          $('#password').val(password1);
          $('#username').val(mobileOrMail);
          $('[data-type="forget_step2"]').hide();
          $('[data-type="login"]').show();
        } else {
          showMessage(getText('passwordChangeFailed'));
        }
      });
    });
  });

  //切换到【sso登录】
  $('#sso-login').on('click', function () {
    $('#dmhub_form').hide();
    $('[data-type="sso_step1"]').show();
  });

  switch (queryMap.error) {
    case 'locked': {
      showMessage(getText('accountLockedMessage'), 10);
      return;
    }
    case 'frozen': {
      showMessage(getText('accountFrozenMessage'), 10);
      return;
    }
    case 'passwordLocked': {
      showMessage(getText('temporaryLockMessage'), 4);
      return;
    }
    case 'captcha': {
      showMessage(getText('captchaErrorMessage'), 4);
      return;
    }
    case 'user':
    case 'password': {
      showMessage(getText('usernamePasswordErrorMessage'), 4);
      return;
    }
    case 'privateKeyExpire': {
      showMessage(getText('loginException'), 4);
      return;
    }
    case 'pending': {
      showMessage(getText('activationRequired'), 4);
      return;
    }
    case 'needVerifyCode': {
      $('#needVerifyCode').show();
      $('.rememberme').hide();
      return;
    }
    case 'verifyCodeInvalid': {
      $('#needVerifyCode').show();
      $('.rememberme').hide();
      showMessage(getText('incorrectVerificationCode'), 4);
      return;
    }
    case 'verifyCodeInvalidFiveTimes': {
      $('#needVerifyCode').show();
      $('.rememberme').hide();
      let timeText = getTimeText(queryMap.lockSeconds);
      showMessage(getText('verificationCodeLocked'), 4);
      return;
    }
    case 'userNotFound': {
      $('#dmhub_form').hide();
      $('[data-type="sso_step1"]').show();
      $('#companyMail').val(queryMap.id);
      showMessage(getText('baseMessageError'), 4);
      return;
    }
    case 'disabled': {
      $('#dmhub_form').hide();
      $('[data-type="sso_step1"]').show();
      $('#companyMail').val(queryMap.id);
      showMessage(getText('userDisabled'), 4);
      return;
    }
  }
};

const registerEventListener = () => {
  //切换到【普通登录方式】
  $('#sso-login-back').on('click', function () {
    $('#dmhub_form').show();
    $('[data-type="sso_step1"]').hide();
    $('#username').val('');
    $('#password').val('');
  });
  //sso登录
  $('#sso-login-action').on('click', function () {
    var companyMail = encodeURI(document.getElementById('companyMail').value.trim());

    var reg =
      /^([a-zA-Z0-9]+[_|\_|\.\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.\-]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
    if (!reg.test(companyMail)) {
      showMessage(getText('baseMessageError'));
      return;
    }

    location.href = `/sso/user/matching?id=${companyMail}`;
  });

  $('#dmhub_form').on('submit', async function (e) {
    // 提交前对密码加密
    // 拦截submit事件对部分提交字段作修改，再调用form.submit提交。
    // 这种流程是否会导致浏览器的密码记忆功能记忆修改后的密码，目前在Chrome和Safari的测试中未发现。
    e.preventDefault();
    const username = document.querySelector('#dmhub_form input[name=username]').value;
    if (!needCaptcha) {
      let captchaNeed = false;
      try {
        const forceShowResult = await captcha.forceShow(username || $('#username').val());
        captchaNeed = forceShowResult.showCaptcha;
      } catch (e) {
        // captcha 服务不可用时不应阻塞登录
      }
      if (captchaNeed) {
        needCaptcha = true;
        document.getElementById('loginCaptchaBtn').click();
        return;
      }
    }

    let encryptLoginInfo = { encryptLogin: false };
    try {
      const encryptResp = await fetch('/loginSecurity/getEncryptLoginInfo');
      encryptLoginInfo = await encryptResp.json();
    } catch (e) {
      // 加密信息获取失败时不应阻塞登录提交
    }
    if (encryptLoginInfo?.encryptLogin) {
      encrypt.setPublicKey(encryptLoginInfo.pubKey);
      document.querySelector('#dmhub_form input[name=password]').value = encrypt.encrypt(
        document.querySelector('#dmhub_form input[name=password]').value
      );
      document.querySelector('#dmhub_form input[name=subKey]').value = encryptLoginInfo.subKey;
    }
    const excludePath = [
      appurl('/login.html'),
      appurl('/index.html'),
      appurl('/application/invitationV2/index.html'),
    ];
    let isExcept = true;
    const pageReferrer = document.referrer.replace(/[^:]\/{2,}/g, s => s.substring(0, 2));
    for (let index = 0; index < excludePath.length; index++) {
      const element = excludePath[index];
      if (pageReferrer.indexOf(location.origin + element) == 0) {
        isExcept = false;
        break;
      }
    }
    if (!pageReferrer.startsWith(window.origin)) isExcept = false;
    if (isExcept) {
      sessionStorage.setItem('_LAST_PATH', pageReferrer);
    } else {
      sessionStorage.setItem('_LAST_PATH', appurl('/index.html'));
    }

    $('#dmhub_form')[0].submit();
  });
};

window.onload = async function () {
  // T521: 清除浏览器中残留的匿名 SESSION cookie。
  // 历史遗留：T521 修复前 BFF 代理回传下游匿名 Set-Cookie 覆盖了已认证 SESSION，
  // 即使代理已修复，浏览器中已被污染的匿名 SESSION cookie 仍会残留，
  // 导致登录后首次 SPA 请求带旧 session → 302 踢回登录页。
  // document.cookie 无法读取 HttpOnly cookie，但可用同名 + Max-Age=0 覆盖删除它。
  document.cookie = 'SESSION=; Max-Age=0; path=/; SameSite=Lax';

  const queryMap = getQueryString();
  // SSO Success without matching user in DMHub
  if (queryMap.error && decodeURIComponent(queryMap.error).indexOf('no local user matched') >= 0) {
    location = 'ssoerr.html';
    return;
  }

  let customLoginPage = null;
  try {
    const response = await $.ajax({
      url: '/globalSetting/customLoginPage',
      type: 'get',
      dataType: 'json',
    });
    customLoginPage = response.customLoginPage;
  } catch (e) {
    // 未登录时此接口可能返回 302/401，忽略错误继续渲染登录页
  }

  if (customLoginPage) {
    document.getElementsByTagName('html')[0].innerHTML = customLoginPage;
  }

  $('body').css('display', 'block');
  try {
    await showMessageAndCaptcha();
  } catch (e) {
    // captcha 初始化失败不应阻塞登录页渲染
  }
  registerEventListener();
};

const COUNT_DOWN_TIME = 1 * 60;
const countDown = function (countDownNumber) {
  const minute = Math.floor(countDownNumber / 60);
  const seconds = countDownNumber % 60;

  let text = '';
  if (minute) {
    text += `${minute}分 `;
  }
  text += `${seconds}秒`;
  const verifyCodeButton = $('[data-type="forget_step2"] .verify-code');
  verifyCodeButton.text(text);
  verifyCodeButton.addClass('disabled');

  setTimeout(function () {
    countDownNumber--;
    if (countDownNumber > 0) {
      countDown(countDownNumber);
    } else {
      verifyCodeButton.text(getText('resendVerificationCode'));
      verifyCodeButton.removeClass('disabled');
    }
  }, 1000);
};

let mobileOrMail, type;

const getCode = data => {
  if (!mobileOrMail) {
    showMessage(getText('enterMobileOrEmail'));
    return;
  }

  const valData = {
    number: mobileOrMail,
  };

  if (location.host.indexOf('jdcloud') > 0) {
    valData.signature = '京东Elite';
  }

  captcha.validate(data.ticket, data.randstr, valData).then(function (result) {
    if (!result.error) {
      $('[data-type="forget_step1"]').hide();

      if (mobileOrMail.indexOf('@') > -1) {
        type = 'email';
      } else {
        type = 'mobile';
      }

      $('[data-target]').text(mobileOrMail);

      countDown(COUNT_DOWN_TIME);

      $('#code').val('');
      $('#password1').val('');
      $('#password2').val('');
      $('[data-type="forget_step2"]').show();
    } else {
      switch (result.error.code) {
        case '400000':
          showMessage(getText('captchaShowError'));
          break;
        case '400002':
          showMessage(getText('captchaValidationError'));
          break;
        default: {
          if (result.error.message == 'sso user not supported') {
            showMessage(getText('ssoUserNotSupported'));
          } else {
            showMessage(getText('captchaValidationError'));
          }
          break;
        }
      }
    }
  });
};

const countDown1 = function (countDownNumber) {
  const minute = Math.floor(countDownNumber / 60);
  const seconds = countDownNumber % 60;

  let text = '';
  if (minute) {
    text += `${minute}分 `;
  }
  text += `${seconds}秒`;
  const verifyCodeButton = $('[data-type="login"] .verify-code');
  verifyCodeButton.text(text);

  setTimeout(function () {
    countDownNumber--;
    if (countDownNumber > 0) {
      countDown1(countDownNumber);
    } else {
      verifyCodeButton.text(getText('resendVerificationCode'));
      verifyCodeButton.removeClass('disabled1');
    }
  }, 1000);
};

//双因子登录
const login2FA = data => {
  const queryMap = getQueryString();
  let reachType = queryMap.reachType || '';
  let reachValue = queryMap.reachValue || '';

  $.ajax({
    url: `/loginSecurity/sendVerifyCode?loginName=${data.loginName}&ticket=${data.ticket}&rands=${data.randstr}`,
    type: 'POST',
    contentType: 'application/json;charset=UTF-8',
  }).then(function (result) {
    let msg = '';
    if (result.code == 'SUCCESS') {
      $('.verify-code-msg').html(getText(`${reachType}VerificationCodeSent`, reachValue));
      $('.verify-code-tip').show();
      setTimeout(function () {
        $('.verify-code-tip').hide();
      }, 6000);
      countDown1(COUNT_DOWN_TIME);
    } else {
      if (result.error.code == '400001') {
        msg = getText('verificationCodeShouldWait');
      } else if (result.error.code == '400000') {
        msg = getText(`${reachType}NotFoundUser`);
      } else {
        msg = getText('sendVerificationCodeFailed');
      }
    }
    if (msg) {
      showMessage(msg);
    }
  });
};
